import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { fetchWithGet } from '../../httpHelper';
import { BrowserRouter as Router, Switch, Route, Link, useRouteMatch, useHistory } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import { Loader } from '../../components';
import { CreateProjectForm } from '../projectForm/CreateProjectForm';
import ProjectDetail from './widgets/ProjectDetail';

export default function ProjectListPage() {
  let { path, url } = useRouteMatch();
  const rootName = 'Project List';

  return (
    <Router>
      <Switch>
        <Route exact path={path}>
          <ProjectList rootPath={url} rootName={rootName} />
        </Route>
        <Route path={`${path}/:id/edit`}>
          <CreateProjectForm rootPath={url} rootName={rootName} />
        </Route>
        <Route path={`${path}/:id`}>
          <ProjectDetail rootPath={url} rootName={rootName} />
        </Route>
      </Switch>
    </Router>
  );
}

function ProjectList({ rootPath, rootName }) {
  const history = useHistory();
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);

  const [data, setData] = useState([]);
  const columns = [
    '#',
    'Enquiry No.',
    'Quotation No.',
    'Invoice No.',
    'Name',
    'Price',
    'Paid',
    'Outstanding',
    'Prepared By',
    'Prepare For',
    'Last Update',
    'Due Date',
    'Status',
  ];
  const options = {
    selectableRows: 'none',
    onRowClick: (rowData, rowMeta) => {
      history.push(`${rootPath}/${projects[rowMeta.dataIndex].id}`);
    },
    print: false,
    textLabels: {
      body: {
        noMatch: isLoading ? <Loader type={'spin'} /> : 'Sorry, no matching records found',
      },
    },
  };
  const fetchApi = async () => {
    setIsLoading(true);
    const result = await fetchWithGet(`/projects/getProjectList?page=${page}&limit=10`);
    if (result) {
      const projectList = result.data.results.filter((v) => v.stage !== 'enquiry' && v.stage !== 'enquiry_failed');
      setProjects([...projects, ...projectList]);
      setData([
        ...data,
        ...projectList.map((v, i) => [
          data.length + i + 1,
          v.enqNo || '',
          v.quoNo || '',
          v.invNo || '',
          `${v.name.en} ${v.name.zh}`,
          v.totalAmount,
          v.totalAmount - (v.outstanding || v.totalAmount),
          v.outstanding || v.totalAmount,
          v.createdBy.name,
          v.userId.name,
          v.lastUpdateStatusTime && moment(v.lastUpdateStatusTime).format('YYYY-MM-DD hh:mm:ss'),
          v.estEndDate && moment(v.estEndDate).format('YYYY-MM-DD'),
          _.startCase(v.stage),
        ]),
      ]);

      if (page < result.data.totalPages) {
        setPage(page + 1);
      }
    }
    setIsLoading(false);
  };
  useEffect(() => {
    fetchApi();
  }, [page]);

  return (
    <div>
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={`${rootPath}`}>{rootName}</Link>
        </BreadcrumbItem>
      </Breadcrumb>
      <MUIDataTable data={data} columns={columns} options={options} />
    </div>
  );
}
